/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InternalTestBrazeEmailSubscriptionRequest} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/internal_test_braze_email_subscription.pb'
import {InternalTestBrazeEmailSubscriptionResponse} from '@cash-web/protos/squareup/cash/notificationsettings/api/v1/internal_test_braze_email_subscription.pb'


export const internalTestBrazeEmailSubscription = (request: InternalTestBrazeEmailSubscriptionRequest, options?: CashRequestOptions) => post<InternalTestBrazeEmailSubscriptionRequest, InternalTestBrazeEmailSubscriptionResponse>("/2.0/cash/internal-test-braze-email-subscription", request, {...options, rejectOnError: true })